import { ArrowCircle, Copy } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import useCopyToClipboard from "hooks/useCopyToClipboard";

type AiChatMessageActionsProps = {
  text: string;
  justify?: "start" | "end";
  className?: string;
  onReuse?: () => void;
};

const AiChatMessageActions = ({
  text,
  justify = "start",
  className,
  onReuse,
}: AiChatMessageActionsProps) => {
  const handleCopy = useCopyToClipboard(text);

  return (
    <Box gap="small" justify={justify} className={className}>
      {onReuse && (
        <ButtonIcon icon={ArrowCircle} variant="ghost" size="small" onPress={onReuse}>
          Use again
        </ButtonIcon>
      )}
      <ButtonIcon icon={Copy} variant="ghost" size="small" onPress={handleCopy}>
        Copy
      </ButtonIcon>
    </Box>
  );
};

export default AiChatMessageActions;
